import { createSelector } from 'reselect';

import { uiSelector } from '@atlassian/jira-issue-view-store/src/common/state/selectors/issue-selector';
import { timeTrackingSelector } from '@atlassian/jira-issue-view-store/src/common/state/selectors/time-tracking-selector';

const worklogUiSelector = createSelector(uiSelector, (ui) => ui.worklog);

export const timeRemainingSecondsSelector = createSelector(
	timeTrackingSelector,
	(timeTracking) => timeTracking.remainingEstimateSeconds || 0,
);

export const loadingStageSelector = createSelector(
	worklogUiSelector,
	(uiState) => uiState.loadingStage,
);

export const highlightedWorklogIdSelector = createSelector(
	worklogUiSelector,
	(uiState) => uiState.highlightedWorklogId,
);
